var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col atom-partner-column"},[_c('a',{staticClass:"atom-partner",attrs:{"href":`${_vm.link}`}},[_c('img',{attrs:{"src":`${_vm.image}`,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }